import { render, staticRenderFns } from "./TEXTAXIS.vue?vue&type=template&id=037d7323&scoped=true&lang=pug"
import script from "./TEXTAXIS.vue?vue&type=script&lang=js"
export * from "./TEXTAXIS.vue?vue&type=script&lang=js"
import style0 from "./TEXTAXIS.vue?vue&type=style&index=0&id=037d7323&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037d7323",
  null
  
)

export default component.exports